var ServicesRequiredCtrl = function ($scope, $state) {
    $scope.goToServices = function () {
        $state.go('bookappointment', {}, { reload: true });
    };
};
ServicesRequiredCtrl.$inject = ['$scope', '$state'];

module.exports = ServicesRequiredCtrl;
